import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(`customer/query/basic_containers/list_containers/${customer_id}/agro_exporter/${agro_exporter_id}`);
  },
  fetchContainers(customer_id, agro_exporter_id) {
    return RequesterV1.get(`customer/query/basic_containers/list_containers/${customer_id}/list/${agro_exporter_id}`);
  },
};
